import zxcvbn from 'zxcvbn';

export const getIsStrongPassword = (password) => {
  if (!password) {
    return false;
  }

  const strength = zxcvbn(password);

  return strength.score === 4;
};
